import { Divider, Heading, Skeleton } from '@chakra-ui/react';
import React from 'react';
import { Navigate } from 'react-router-dom';

import { useGetUserActiveCreditFacilitiesQuery } from 'types/dashboard-core-gqlTypes.generated.d';

import { SettingsFacilitiesTable } from '~/capitalProvider/domains/settings/SettingsFacilitiesTable';
import { useFeatureFlags } from '~/contexts/FeatureFlagProvider';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { SettingsViewTemplate } from '~/core/routes/settings/SettingsTemplate';

import 'source/borrower/borrower.scss';

// Fragments
const RouteBase = () => {
  const flags = useFeatureFlags();
  const userQuery = useGetUserActiveCreditFacilitiesQuery({
    variables: {
      creditFacilitySlugsToHide: flags.creditFacilitySlugsToHide ?? [],
    },
  });
  if (userQuery.error) throw userQuery.error;
  if (userQuery.loading || !userQuery.data?.user) {
    return (
      <Skeleton
        height="600px"
        data-testid="settings-facilities-route-loading"
      />
    );
  }

  return (
    <>
      <Heading as="h2" mb="16px" fontSize="36px" fontWeight={600}>
        Facilities
      </Heading>
      <Divider mb="40px" />
      <SettingsFacilitiesTable
        creditFacilities={userQuery.data.user.organization.creditFacilities}
      />
    </>
  );
};

// Exports
export const Route = () => {
  const flags = useFeatureFlags();
  if (!flags.displayLenderSettingsFacilities) {
    return <Navigate to="/settings" />;
  }

  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/settings" />;
      }}
    >
      <SettingsViewTemplate>
        <RouteBase />
      </SettingsViewTemplate>
    </RouteErrorBoundary>
  );
};
